import { render, staticRenderFns } from "./MemberDetailTokens.vue?vue&type=template&id=12b05f88"
import script from "./MemberDetailTokens.vue?vue&type=script&lang=js"
export * from "./MemberDetailTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports